import { CountryCode } from '@carsys/enums/country-code'
import { VehicleSource, WholesaleCatalogType } from '@cbgms/api'
import { VehicleIdType } from '@cbgms/api/modules/enums/vehicle-id-type'

export interface VPOMTreeConfig {
  TreeUUID: string
}

export interface ExternalPortal {
  Name: string
  UniqueKey: string
  ImageUrlTemplate: string
  Path: string
  ShouldOpenNewTab: boolean
  Selected: boolean
}

export type OrderInPreparation = ExternalPortal
export type AddToOrderMenu = ExternalPortal
export type QuickNavigationProductGroup = ExternalPortal

export interface DashboardCatalogInfo {
  ExternalPortal: ExternalPortal[]
  OrderInPreparation: OrderInPreparation[]
  AddToOrderMenu: AddToOrderMenu[]
  QuickNavigationProductGroup: []
}

export interface Group {
  TreeUUID: string
}

export interface DashboardCatalogConfig {
  ExternalPortals: ExternalPortal[]
  Groups: Group[]
  OrderInPreparation: OrderInPreparation[]
  AddToOrderMenu: AddToOrderMenu[]
  QuickNavigationProductGroup: QuickNavigationProductGroup[]
}

export interface IFormValues {
  wholesaleCatalogType: WholesaleCatalogType
  CarsysProductTreeUUID?: string

  VehiclePrimaryVehicleSource: VehicleSource
  VehicleSources: VehiclesSourceConfig[]

  // VPOM Settings
  VPOMProductTreeID?: string
  VPOMDashboardCatalogUUIDS?: VPOMTreeConfig[]
  DashboardCatalogInfo?: DashboardCatalogConfig
  VPOMUseDevelopmentAPI: boolean
  VPOMHidePDHForNonTyres: boolean
  RemoteIDOverride?: string
  ExhaustGroupPlaceholder?: string
  SteeringGroupPlaceholder?: string

  // HbaseSettings:
  HbaseOverrideSupplierID?: string
  HbaseOverrideAPIKey?: string
  HbaseOverrideMGAppID?: string
  HbaseOverrideMGAppSecret?: string
  HbaseMapSurchargeFromCatalog?: boolean

  // MDM Settings:
  MDMOverrideApplicationID?: string
  MDMOverrideUsername?: string
  MDMOverridePassword?: string
  MDMUseVPOMVehicles?: boolean
  MDMUseDevelopAPI?: boolean

  // TecDoc Settings:
  TecDocOverrideProvider?: string
  TecDocOverrideAPIKey?: string

  // Quick navigate to productgroup:
  QuickNavToProductGroupUUIDS: VPOMTreeConfig[]
}

export interface VehiclesSourceConfig {
  Country: CountryCode
  Source: VehicleSource
  Target: VehicleIdType
}

export enum DashboardCatalogSectionKey {
  ExternalPortals = 'ExternalPortals',
  OrderInPreparation = 'OrderInPreparation',
  AddToOrderMenu = 'AddToOrderMenu',
  QuickNavigationProductGroup = 'QuickNavigationProductGroup'
}
